import e from "react";
import { c, t as s } from "./app-a75c1d35.mjs";
import { u } from "./useClickOutside-726e7c36.mjs";
import { B as r } from "./Block-9b78bd10.mjs";
import { I as y, a as E } from "./Image-d6406817.mjs";
import { L as b } from "./Link-479ac100.mjs";
import { B as m } from "./Button-c598cb52.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
import "./LinkContext-0c83848a.mjs";
import "./Icon-3122c134.mjs";
const x = "ctaBanner", l = "ctaBanner__image", L = "ctaBanner__content", _ = "ctaBanner__button-container", f = "ctaBanner__credits";
const k = "ctaBanner--has-image", C = "ctaBanner--employer", I = "ctaBanner--button-only", N = "ctaBanner--white", T = "ctaBanner--light-blue", P = "ctaBanner--gray", S = "post-article-section";
const j = (B) => {
  const { headline: a, body: n, image: t, link: o, btnText: d, alignToArticleSection: g, backgroundColor: i } = B, h = t?.altText === "", p = u();
  return /* @__PURE__ */ e.createElement(
    r,
    {
      topPadding: r.Padding.LARGE,
      bottomPadding: r.Padding.LARGE,
      className: c(
        x,
        p && C,
        !!t && k,
        !a && !n && I,
        !a && !n && i === "white" && N,
        !a && !n && i === "lightBlue" && T,
        !a && !n && i === "gray" && P,
        g && S
      ),
      "data-testid": "cta-banner-block"
    },
    t && (h ? /* @__PURE__ */ e.createElement(
      "img",
      {
        src: t.imageLoader?.() || t.src,
        width: t.width,
        height: t.height,
        alt: "",
        "aria-hidden": "true",
        className: l,
        "data-testid": "cta-banner-image"
      }
    ) : /* @__PURE__ */ e.createElement(
      y,
      {
        credits: t.credits,
        src: t.src,
        width: t.width,
        height: t.height,
        altText: t.altText,
        imageLoader: t.imageLoader,
        className: l,
        styling: E.PREVIEW_CARD,
        "data-testid": "cta-banner-image"
      }
    )),
    /* @__PURE__ */ e.createElement(r.Content, { flex: !0, className: L }, !!a && /* @__PURE__ */ e.createElement("h2", { className: c(s.headingSection) }, a), !!n && /* @__PURE__ */ e.createElement("p", { className: c(s.textsLeadText) }, n), /* @__PURE__ */ e.createElement("div", { className: _ }, /* @__PURE__ */ e.createElement(
      b,
      {
        className: m.PrimaryFocusStyleInLink,
        href: o.href,
        target: o.isExternalLink ? "_blank" : void 0,
        disableLinkTextStyle: !0,
        itemProp: "url"
      },
      /* @__PURE__ */ e.createElement(
        m.Primary,
        {
          text: d || o.title,
          asDiv: !0
        }
      )
    ))),
    t && /* @__PURE__ */ e.createElement(r.Content, { flex: !0, className: f }, /* @__PURE__ */ e.createElement("div", { className: c(s.buttonTextPrimary) }, t.credits))
  );
};
export {
  j as CTABanner
};
//# sourceMappingURL=CTABanner.js.map
